import { RootState } from "rootReducer";

export const selectAllToasts = (state: RootState) => state.toasts;
